import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useContext } from 'react';
import { ComponentDependencyContext } from "./ComponentDependencyContext";
export var withConfig = function withConfig(propName) {
  return function (Component) {
    var ComponentWithConfig = function ComponentWithConfig(props) {
      var context = useContext(ComponentDependencyContext);
      var configContext = useContext(context.ConfigContext);
      return /*#__PURE__*/React.createElement(Component, Object.assign({}, _defineProperty({}, propName, configContext), props));
    };
    ComponentWithConfig.displayName = "withConfig(".concat(Component.displayName || Component.name, ")");
    return ComponentWithConfig;
  };
};
export default withConfig('config');